module.exports = __webpack_public_path__ + "static/media/aids-center-logo.82359b84.png";